import { useState } from 'react';

const HIDE_ISSUES_STORAGE_KEY = 'ordersListHideIssues';

export function readHideIssuesSetting(): boolean {
  return sessionStorage.getItem(HIDE_ISSUES_STORAGE_KEY) === 'true';
}

export function writeHideIssuesSetting(hideIssues: boolean): void {
  sessionStorage.setItem(HIDE_ISSUES_STORAGE_KEY, String(hideIssues));
}

export function useOrdersListHideIssues(): {
  readonly hideIssues: boolean;
  readonly toggleHideIssues: () => void;
} {
  const [hideIssues, setHideIssues] = useState(readHideIssuesSetting);

  const toggleHideIssues = (): void => {
    setHideIssues((prev) => {
      const next = !prev;
      writeHideIssuesSetting(next);
      return next;
    });
  };

  return { hideIssues, toggleHideIssues };
}
